import type { AppRouteRecordRaw } from '@/router/types';
import type { RouteRecordRaw } from 'vue-router';
import type { App } from 'vue';

import { createRouter, createWebHashHistory } from 'vue-router';

import Layout from '@/layout/index.vue';

export const routes: Array<AppRouteRecordRaw> = [
  {
    path: '',
    redirect: '/home',
    name: 'MainHome',
    component: Layout,
    meta: {
      title: '首页',
    },
    children: [
      {
        path: 'home',
        name: 'Home',
        component: () => import('@/views/Home.vue'),
        meta: {
          title: '首页',
        },
      },
    ],
  },
  {
    path: '/edit-password',
    name: 'EditPassword',
    component: () => import('@/views/edit-password/index.vue'),
    meta: {
      title: '修改密码',
    },
  },
  {
    path: '/edit-mobile',
    name: 'EditMobile',
    component: () => import('@/views/edit-mobile/index.vue'),
    meta: {
      title: '手机绑定',
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/index.vue'),
    meta: {
      title: '登录',
    },
  },
  {
    path: '/:path(.*)*',
    name: 'ErrorPage',
    component: () => import('@/views/error/404.vue'),
    meta: {
      title: '错误页面',
    },
  },
];

export const asyncRoutes: Array<AppRouteRecordRaw> = [
  {
    path: '/view-data-board',
    name: 'ViewDataBoard',
    component: Layout,
    meta: {
      permissions: true,
      title: '数据看板',
    },
    children: [
      {
        path: 'data-board',
        name: 'DataBoard',
        component: () => import('@/views/data-board/index.vue'),
        meta: {
          title: '数据看板',
          permissions: true,
        },
      },
      {
        path: 'overdue-data-board',
        name: 'OverdueDataBoard',
        component: () => import('@/views/overdue-data-board/index.vue'),
        meta: {
          title: '超时看板',
          permissions: true,
        },
      },
    ],
  },
  {
    path: '/big-data-service',
    name: 'BigDataService',
    component: Layout,
    redirect: '/big-data-service/bds-mian',
    meta: {
      permissions: true,
      title: '大数据看板',
    },
    children: [
      {
        path: 'bds-mian',
        name: 'BDSMain',
        component: () => import('@/views/screen/main/index.vue'),
        meta: {
          title: '大数据主页',
          permissions: true,
        },
      },
    ],
  },
  {
    path: '/big-data-service/t-mall',
    name: 'BDSTmallScreen',
    component: () => import('@/views/screen/t-mall-screen/index.vue'),
    meta: {
      permissions: true,
      title: 'T-MALL大屏',
    },
  },
  {
    path: '/big-data-service/device-screen',
    name: 'BDSDeviceScreen',
    component: () => import('@/views/screen/device-screen/index.vue'),
    meta: {
      permissions: true,
      title: '设备大屏',
    },
  },
  {
    path: '/big-data-service/business-screen',
    name: 'BDSBusinessScreen',
    component: () => import('@/views/screen/business-screen/index.vue'),
    meta: {
      permissions: true,
      title: '业务大屏',
    },
  },
  {
    path: '/big-data-service/business-device-screen',
    name: 'BDSBusinessDeviceScreen',
    component: () => import('@/views/screen/business-device-screen/index.vue'),
    meta: {
      permissions: true,
      title: '业务设备轮播大屏',
    },
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes: routes as unknown as RouteRecordRaw[],
  strict: true,
  scrollBehavior: () => ({ left: 0, top: 0 }),
});

export function setupRouter(App: App<Element>) {
  App.use(router);
}

export function hasRoutePermission(routeName: string) {
  return router.getRoutes().findIndex((route) => {
    return route.name === routeName;
  }) !== -1
    ? true
    : false;
}

export default router;
